import React from 'react';
import { Box, Stack, Text } from '@mantine/core';
import { motion } from 'framer-motion';
import ShellLogo from '@/components/appshell/Shell.Logo';
import { FADE_UP, STAGGER_SLOW } from '@/theme/motion';
import { AUTH_COPY, HIGHLIGHTS } from '@/components/auth/frame/config/auth.labels';

const AuthAside: React.FC = () => (
    <Box
        visibleFrom="md"
        style={{
            padding: 'clamp(2rem, 4vw, 3.5rem)',
            background: 'linear-gradient(150deg, var(--bd-brand-soft) 0%, var(--bd-surface-sunken) 100%)',
            borderInlineEnd: '1px solid var(--bd-border)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            gap: '2rem',
        }}
    >
        <ShellLogo />

        <motion.div variants={STAGGER_SLOW} initial="hidden" animate="visible">
            <Stack gap="xl" style={{ maxWidth: '34ch' }}>
                <motion.div variants={FADE_UP}>
                    <Text fz="clamp(1.5rem, 2.6vw, 2.125rem)" fw={800} lh={1.2} style={{ letterSpacing: '-0.02em', color: 'var(--bd-text-strong)' }}>
                        {AUTH_COPY.subtitle}
                    </Text>
                </motion.div>

                <Stack gap="lg">
                    {HIGHLIGHTS.map((item) => (
                        <motion.div key={item.title} variants={FADE_UP}>
                            <Text fz="sm" fw={700} style={{ color: 'var(--bd-brand-text)' }}>{item.title}</Text>
                            <Text fz="sm" c="dimmed" lh={1.6}>{item.body}</Text>
                        </motion.div>
                    ))}
                </Stack>
            </Stack>
        </motion.div>

        <Text fz="xs" c="dimmed">{AUTH_COPY.identityNote}</Text>
    </Box>
);

export default AuthAside;
